import React from 'react';

import {
  FormControl, InputLabel, MenuItem, Select,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import DateSelector from '../../DateSelector';
import HealthRecordView from '../../HealthRecordView';
import {
  classChildSelector,
  dateSelector,
  pageSelector,
} from '../../selector';
import {
  alreadyRead, refreshHealthRecords, refreshPage,
} from '../../thunk';

import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';
import type { UserType } from '@/types/domain/user/redux';

/**
 * プロパティ
 */
export type Props = {
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
  /** 施設リスト */
  facilityList: FacilityJson[],
};

const HealthRecordDaily: React.FC<Props> = ({
  user,
  child,
  facilityList,
}) => {
  const dispatch = useDispatch();
  const date = useSelector(dateSelector);
  const page = useSelector(pageSelector);
  const classChildList = useSelector(classChildSelector);
  const classChild = classChildList.find(
    (v) => v.data.parentId === child.parentId && v.data.childId === child.childId,
  );
  const healthRecordTypes = classChild?.data.childNotebookContents || [];
  const [facilityId, setFacilityId] = React.useState(facilityList[0]?.data.facilityId || '');
  React.useEffect(() => {
    if (page === undefined) {
      dispatch(refreshPage());
      dispatch(refreshHealthRecords());
    }
  }, [dispatch, page]);
  React.useEffect(() => {
    if (page?.page !== undefined && page.page.pub.data.alreadyRead === false) {
      // 既読判定
      dispatch(alreadyRead({
        data: page.page,
      }));
    }
  }, [dispatch, date, page, facilityList]);
  if (facilityList.length === 0) {
    return (
      <div>
        <p>有効な施設が見つかりませんでした。</p>
      </div>
    );
  }
  return (
    <div>
      <DateSelector date={date} />
      {facilityList.length > 1 && (
        <FormControl fullWidth style={{ marginBottom: '10px' }}>
          <InputLabel>施設</InputLabel>
          <Select
            value={facilityId}
            label="施設"
            onChange={(e) => setFacilityId(e.target.value)}
          >
            {facilityList.map((v) => (
              <MenuItem
                value={v.data.facilityId}
                key={v.data.facilityId}
              >
                {v.data.facilityName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {page && (
        <div>
          <h3 style={{ margin: '1.5em 0 0 0' }}>健康記録</h3>
          <HealthRecordView
            user={user}
            child={child}
            facilityList={facilityList}
            healthRecords={page.healthRecords}
            healthRecordTypes={healthRecordTypes}
            date={date}
          />
        </div>
      )}
    </div>
  );
};

export default HealthRecordDaily;
